document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined') return;

  document.documentElement.style.overflowX = 'clip';
  document.body.style.overflowX = 'clip';

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  if (prefersReducedMotion) {
    gsap.set('.fade-up, .fade-left, .fade-right', {
      opacity: 1,
      x: 0,
      y: 0
    });

    return;
  }

  const heroTimeline = gsap.timeline({
    defaults: {
      duration: 1,
      ease: 'power3.out'
    }
  });

  heroTimeline.fromTo(
    '.hero-section',
    {
      '--mic-y': '60px',
      '--mic-opacity': 0
    },
    {
      '--mic-y': '0px',
      '--mic-opacity': 1
    },
    0
  );

  heroTimeline.fromTo(
    '.hero-section .fade-up',
    {
      y: 70,
      opacity: 0
    },
    {
      y: 0,
      opacity: 1
    },
    0
  );

  heroTimeline.fromTo(
    '.hero-section .fade-left',
    {
      x: -70,
      opacity: 0
    },
    {
      x: 0,
      opacity: 1
    },
    0
  );

  heroTimeline.fromTo(
    '.hero-section .fade-right',
    {
      x: 70,
      opacity: 0
    },
    {
      x: 0,
      opacity: 1
    },
    0
  );

  if (typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const animatedElements = gsap.utils.toArray(
    '.fade-up, .fade-left, .fade-right'
  ).filter(function (element) {
    return !element.closest('.hero-section');
  });

  animatedElements.forEach(function (element) {
    if (element.classList.contains('fade-up')) {
      gsap.set(element, {
        y: 80,
        x: 0,
        opacity: 0
      });
    }

    if (element.classList.contains('fade-left')) {
      gsap.set(element, {
        x: -80,
        y: 0,
        opacity: 0
      });
    }

    if (element.classList.contains('fade-right')) {
      gsap.set(element, {
        x: 80,
        y: 0,
        opacity: 0
      });
    }
  });

  const sections = [
    ...new Set(
      animatedElements.map(function (element) {
        return (
          element.closest('.shopify-section') ||
          element.closest('section') ||
          element.parentElement
        );
      })
    )
  ];

  sections.forEach(function (section) {
    const elements = animatedElements.filter(function (element) {
      const parentSection =
        element.closest('.shopify-section') ||
        element.closest('section') ||
        element.parentElement;

      return parentSection === section;
    });

    if (!elements.length) return;

    const timeline = gsap.timeline({
      paused: true,
      defaults: {
        duration: 1.05,
        ease: 'power3.out'
      }
    });

    elements.forEach(function (element, index) {
      timeline.to(
        element,
        {
          x: 0,
          y: 0,
          opacity: 1
        },
        index * 0.12
      );
    });

    ScrollTrigger.create({
      trigger: section,
      start: 'top 82%',
      once: true,

      onEnter: function () {
        timeline.play();
      }
    });
  });

  requestAnimationFrame(function () {
    ScrollTrigger.refresh();
  });

  window.addEventListener('load', function () {
    ScrollTrigger.refresh();
  });
});

(function () {
  function moveArisOptions() {
    document.querySelectorAll('.product-form-buttons').forEach(function (buttons) {
      const arisOptions = buttons.querySelector('.avpoptions-container__v2');
      const quantity = buttons.querySelector('.quantity-selector-wrapper');

      if (!arisOptions || !quantity) return;

      if (quantity.nextElementSibling !== arisOptions) {
        quantity.insertAdjacentElement('afterend', arisOptions);
      }
    });
  }

  moveArisOptions();

  const observer = new MutationObserver(function () {
    moveArisOptions();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', moveArisOptions);
})();

document.addEventListener('input', function (event) {
  if (
    event.target.matches(
      '.avpoptions-container__v2 input[name="Customized Engraving"]'
    )
  ) {
    event.target.style.setProperty('color', '#fff', 'important');
    event.target.style.setProperty('-webkit-text-fill-color', '#fff', 'important');
  }
});
